export function isNullish(val) {
    return val === null || val === undefined;
}
export function isNumeric(value) {
    return typeof value === 'number' || /^\d+$/.test(value);
}
//# sourceMappingURL=typeof.js.map